export default {
  namespaced: true,
  state: {},
  actions: {
    list ({ commit, state, getters, rootState }, creds) {
      return this.dispatch('request', { method: 'get', url: 'shipments/export_fields' })
      .then(
        response => {
          return response.data
        }
      ).catch(error => {
        throw error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shipmentFields.js